module.exports = __webpack_public_path__ + "static/media/icon-facebook-color.d7eac34f.svg";